import { runtimeEnv } from "config/runtimeEnv";
import {API_ENDPOINT}  from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "../utils/utils";

let env = runtimeEnv("API_BASE_URL")
const businessType = localStorage?.getItem('businessType');

export const complianceApi = async(data) => {
  let url = ""
  const page = data?.page === 0 || data?.page ? data?.page+1 : 1
  if(data?.id){
    url = `${env}${API_ENDPOINT.Compliance.api+'/'+data.id}`
  }else{
    url = `${env}${API_ENDPOINT.Compliance.api+'?complianceType='+data?.type+"&status="+data?.status+"&dateFrom="+data?.dateFrom+"&dateTo="+data?.dateTo+"&page="+page+"&pageSize="+data?.pageSize+"&search="+(data?.search ? data?.search : '')}&${businessType}=${(data?.type === 'driverRegistration' || data?.type === 'vehicleRegistration' ? 'true' : 'true')}`
  }
  const res = await requestInstance.get(
    url
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

export const  approveComplianceApi = async(data) => {
  const res = await requestInstance.post(
    `${env}${API_ENDPOINT.ConfigCompliance.verificationApi}`,
    data
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

export const configComplianceApi = async(data) => {
  const page = data?.page === 0 || data?.page ? data?.page+1 : 1
  const res = await requestInstance.get(
    `${env}${API_ENDPOINT.ConfigCompliance.api}?type=${data.type}&page=${page}&pageSize=${data?.pageSize}`
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

export const onBoardComplianceApi = async(data) => {
  let url = ""
  if(data?.vehicleId){
    url = `${env}${API_ENDPOINT.OnBoardCompliance.api+'?complianceType='+data?.type+"&vehicleId="+data?.vehicleId}`
  }else{
    url = `${env}${API_ENDPOINT.OnBoardCompliance.api}`
  }
  const res = await requestInstance.get(
    url
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

export const  addComplianceApi = async(data) => {
  const res = await requestInstance.post(
    `${env}${API_ENDPOINT.ConfigCompliance.api}`,
    data
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

export const  updateComplianceApi = async(data) => {
  const res = await requestInstance.patch(
    `${env}${API_ENDPOINT.ConfigCompliance.api+'/'+data.id}`,
    data
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

export const  addOnBoardComplianceApi = async(data) => {
  const res = await requestInstance.post(
    `${env}${API_ENDPOINT.OnBoardCompliance.api}`,
    data
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}
